import { Link, useLocation } from 'react-router-dom';
import { HashLink } from 'react-router-hash-link';
import React, { useEffect, useState, useRef } from 'react';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import { gsap } from 'gsap';
import '../css/App.css'; // Assume you have some CSS for styling

export default function MenuItem({theme, href, icon, children, title, target = '_self', defaultOpen = true}) {
  const location = useLocation(); // Get the current location
  const submenuRef = useRef(null);
  const submenuIconRef = useRef(null);

  const [isOpen, setIsOpen] = useState(defaultOpen);
  const [submenuHeight, setSubmenuHeight] = useState(defaultOpen ? null : 0);
  const [isAnimating, setIsAnimating] = useState(false);

  useEffect(() => {
    init();
    if(!isOpen) close()
  }, []);

  const init = () => {
    setSubmenuHeightToClientHeight();
    if (submenuIconRef.current) {
      gsap.to(submenuIconRef.current, { rotation: isOpen ? -90 : 0, duration: 0 });
    }
  };

  const toggle = async (event) => {
    children && isOpen ? await close(event) : await open(event);
  };

  const setSubmenuHeightToClientHeight = () => {
    if (submenuRef.current) {
      if (
        submenuHeight !== submenuRef.current.clientHeight &&
        submenuRef.current.clientHeight !== undefined &&
        submenuRef.current.clientHeight !== null &&
        submenuRef.current.clientHeight !== 0
      ) {
        setSubmenuHeight(submenuRef.current.clientHeight);
      }
    }
  };

  const open = async () => {
    if (!isAnimating) {
      setIsAnimating(true);
      setIsOpen(true);
      setSubmenuHeightToClientHeight();
      if (submenuRef.current) {
        gsap.fromTo(submenuRef.current, { height: 0 }, {
          height: submenuHeight,
          onComplete: () => {
            setIsAnimating(false);
            if (submenuRef.current) {
              submenuRef.current.style.height = null;
            }
          }
        });
        if (submenuIconRef.current) {
          gsap.fromTo(submenuIconRef.current, { rotation: 0 }, { rotation: -90 });
        }
      }
    }
  };

  const close = async () => {
    if (!isAnimating) {
      setIsAnimating(true);
      setSubmenuHeightToClientHeight();
      if (submenuIconRef.current) {
        gsap.fromTo(submenuIconRef.current, { rotation: -90 }, { rotation: 0 });
      }
      if (submenuRef.current) {
        submenuRef.current.style.height = submenuHeight;
        gsap.fromTo(submenuRef.current, { height: submenuHeight }, {
          height: 0,
          onComplete: () => {
            setIsOpen(false);
            setIsAnimating(false);
          }
        });
      }
    }
  };

  // Determine whether this menu item is active
  const isActive = location.pathname === href;
  const activeClass = isActive ? 'active' : '';
  let className = isOpen ? 'treeview-menu visible' : 'treeview-menu';
  className += ' ' + (theme ?? '');
  let link = ('' + href).indexOf('#') > -1 ?
    <HashLink to={href} onClick={toggle} className={activeClass}>
      {icon}
      <span>{title}</span>
      {children?.length && <ChevronLeftIcon className="submenu-icon" ref={submenuIconRef} />}
    </HashLink>
    :
    <Link to={href} target={target} onClick={async event => { await toggle(event) }} className={activeClass}>
      {icon}
      <span>{title}</span>
      {children?.length && <ChevronLeftIcon className="submenu-icon" ref={submenuIconRef} />}
    </Link>;

  return (
    <li className={`menu-item ${activeClass}`}>
      {link}
      {children && 
        <div ref={submenuRef} style={{ overflow: 'hidden' }}>
          <ul className={className}>{children}</ul>
        </div>
      }
    </li>
  );
}